// extracted by mini-css-extract-plugin
export default {"keypad":"styles_keypad__wu7Co","keyBtn":"styles_keyBtn__eQYNz"};